import { render, staticRenderFns } from "./commupdate2023.vue?vue&type=template&id=13b186fa&scoped=true&"
import script from "./commupdate2023.vue?vue&type=script&lang=js&"
export * from "./commupdate2023.vue?vue&type=script&lang=js&"
import style0 from "./commupdate2023.vue?vue&type=style&index=0&id=13b186fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b186fa",
  null
  
)

export default component.exports